import { useQuery as n } from "@tanstack/vue-query";
const t = ["dictionary"], y = 1e3, u = 60, o = 60, a = y * u * o, r = {
  all: t,
  /** Query key for mode-aware countries (flat vs full with regions). */
  countries: (e) => [...t, "countries", e],
  os: (e) => [...t, "os", e],
  deviceTypes: () => [...t, "deviceTypes"],
  browserTypes: () => [...t, "browserTypes"],
  languages: () => [...t, "languages"],
  adUnitTypes: (e) => [...t, "adUnitTypes", e],
  categories: () => [...t, "categories"],
  dealTypes: () => [...t, "dealTypes"],
  contentTypes: () => [...t, "contentTypes"],
  cpaAutoRules: () => [...t, "cpaAutoRules"],
  blacklistStatuses: () => [...t, "blacklistStatuses"],
  blacklistBanTypes: () => [...t, "blacklistBanTypes"],
  blacklistConditionParams: () => [...t, "blacklistConditionParams"],
  adUnitOwners: () => [...t, "adUnitOwners"],
  adUnitSites: () => [...t, "adUnitSites"],
  advertisers: () => [...t, "advertisers"],
  managers: () => [...t, "managers"],
  userGrants: () => [...t, "userGrants"],
  paymentTypes: () => [...t, "paymentTypes"],
  ssps: () => [...t, "ssps"],
  dsps: () => [...t, "dsps"],
  adTags: () => [...t, "adTags"],
  bannerSizes: () => [...t, "bannerSizes"]
}, l = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.deviceTypes(),
  queryFn: () => e.dictionary.getDeviceTypes({})
}), T = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.browserTypes(),
  queryFn: () => e.dictionary.getBrowserTypes({})
}), d = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.languages(),
  queryFn: () => e.dictionary.getLanguages({})
}), p = (e, s = "full", i) => n({
  staleTime: a,
  ...i,
  queryKey: r.adUnitTypes(s),
  queryFn: () => e.dictionary.getAdUnitTypes({ mode: s })
}), g = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.categories(),
  queryFn: () => e.dictionary.getCategories({})
}), q = (e, s = "full", i) => n({
  staleTime: a,
  ...i,
  queryKey: r.countries(s),
  queryFn: () => e.dictionary.getCountries({ mode: s })
}), m = async (e, s) => {
  await e.prefetchQuery({
    queryKey: r.countries("full"),
    queryFn: async () => s.dictionary.getCountries({ mode: "full" })
  });
}, S = (e, s = "full", i) => n({
  staleTime: a,
  ...i,
  queryKey: r.os(s),
  queryFn: () => e.dictionary.getOperatingSystems({ mode: s })
}), K = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.dealTypes(),
  queryFn: () => e.dictionary.getDealTypes({})
}), F = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.contentTypes(),
  queryFn: () => e.dictionary.getContentTypes({})
}), C = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.cpaAutoRules(),
  queryFn: () => e.dictionary.getCpaAutoRules({})
}), U = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.blacklistStatuses(),
  queryFn: () => e.dictionary.getBlacklistStatuses({})
}), A = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.blacklistBanTypes(),
  queryFn: () => e.dictionary.getBlacklistBanTypes({})
}), B = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.blacklistConditionParams(),
  queryFn: () => e.dictionary.getBlacklistConditionParams({})
}), b = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.adUnitOwners(),
  queryFn: () => e.dictionary.getAdUnitOwners({})
}), k = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.advertisers(),
  queryFn: () => e.dictionary.getAdvertisers({})
}), O = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.managers(),
  queryFn: () => e.dictionary.getManagers({})
}), I = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.paymentTypes(),
  queryFn: () => e.dictionary.getPaymentTypes({})
}), w = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.userGrants(),
  queryFn: () => e.dictionary.getUserGrants({})
}), D = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.adUnitSites(),
  queryFn: () => e.dictionary.getAdUnitSites({})
}), v = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.ssps(),
  queryFn: () => e.dictionary.getSsps({})
}), N = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.dsps(),
  queryFn: () => e.dictionary.getDsps({})
}), _ = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.adTags(),
  queryFn: () => e.dictionary.getAdTags({})
}), f = (e, s) => n({
  staleTime: a,
  ...s,
  queryKey: r.bannerSizes(),
  queryFn: () => e.dictionary.getBannerSizes({})
});
export {
  r as dictionaryKeys,
  m as prefetchCountriesTree,
  _ as useAdTags,
  b as useAdUnitOwners,
  D as useAdUnitSites,
  p as useAdUnitTypes,
  k as useAdvertisers,
  f as useBannerSizes,
  A as useBlacklistBanTypes,
  B as useBlacklistConditionParams,
  U as useBlacklistStatuses,
  T as useBrowserTypes,
  g as useCategories,
  F as useContentTypes,
  q as useCountries,
  C as useCpaAutoRules,
  K as useDealTypes,
  l as useDeviceTypes,
  N as useDsps,
  d as useLanguages,
  O as useManagers,
  S as useOperatingSystems,
  I as usePaymentTypes,
  v as useSsps,
  w as useUserGrants
};
//# sourceMappingURL=queries.js.map
